webpackJsonp([498],{

/***/ 1149:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": "Vue querystring url 参数解析 | VUX - Vue 移动端 UI 组件库", "ignoreSuffixChar": "|" }
});

/***/ }),

/***/ 2103:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(1149),
  /* template */
  __webpack_require__(2853),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/data/vux/home/websites/vux-repo/docs/node_modules/v-markdown-loader/_cache/querystring-460.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] querystring-460.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-70bd9322", Component.options)
  } else {
    hotAPI.reload("data-v-70bd9322", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2853:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("url 参数解析")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { querystring } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n\nquerystring.parse("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'a=b&c=d'")]), _vm._v(") "), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// {a:'b',c:'d'}, 默认参数为 location.search")]), _vm._v("\n\nquerystring.stringify({"), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("a")]), _vm._v(":"), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'b'")]), _vm._v(","), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("c")]), _vm._v(":"), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'d'")]), _vm._v("}) "), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// 'a=b&c=d'，注意不支持复杂嵌套的结构")]), _vm._v("\n")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-70bd9322", module.exports)
  }
}

/***/ }),

/***/ 920:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2103);

/***/ })

});


// WEBPACK FOOTER //
// 498.a80d89ea.js